<style lang="less" scoped>
  .demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
  }
  @keyframes ani-demo-spin {
    from {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(180deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  .demo-spin-col {
    height: 100px;
    position: relative;
    border: 1px solid #eee;
  }
  .main {
    padding-top: 45px;
    padding-bottom: 50px;
    min-height: 100%;
  }
  .nav {
    background-color: #000;
    height: 45px;
    border-bottom: 1px solid #eee;
    overflow: hidden;
    color: #fff;
    text-align: center;
    line-height: 45px;
    font-size: 14px;
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 999;
    .ivu-icon {
      margin-top: 12px;
      margin-left: 10px;
      float: left;
    }
  }
  .bottom-bar {
    background: #fff;
    position: fixed;
    bottom: 0;
    height: 50px;
    width: 100%;
    border-top: 1px solid #eee;
    z-index: 99;
    .bar-left {
      width: 100px;
      float: left;
      position: relative;
      text-align: center;
      padding-top: 3px;
    }
    .bar-left::before {
      content: '';
      position: absolute;
      height: 50px;
      width: 1px;
      background: #eee;
      right: 0;
      top: 0;
    }
    .bar-right {
      margin-left: 100px;
      line-height: 50px;
      text-align: center;
      .right-left {
        float: left;
        width: 50%;
      }
      .right-right {
        float: left;
        width: 50%;
        color: #fff;
        background: #ff6615;
      }
    }
  }
  .diy-box {
    width: 100%;
    margin: auto;
    margin-top: 15px;
    position: relative;
    z-index: 1;
    height: 100%;
    .step_name {
      font-size: 20px;
      color: #ff6615;
      font-weight: 700;
      margin-bottom: 15px;
      padding-left: 15px;
    }
    .parameter_li {
      background: #fff;
      padding: 0px 15px;
      overflow: hidden;
      padding-right: 0px;
    }
    .parameter_name {
      font-size: 16px;
      color: #333;
      font-weight: 700;
      margin-bottom: 15px;
      margin-top: 15px;
    }
    .parameter_box {
      padding-bottom: 15px;
      overflow: hidden;
      overflow-x: auto;
      position: relative;
      border-bottom: 1px solid #eee;
      .ivu-icon {
        position: absolute;
      }
      .ivu-icon-ios-checkmark-circle {
        right: 0px;
        top: 0px;
        color: #ff6615;
      }
      .ivu-icon-md-create {
        left: 5px;
        bottom: 5px;
      }
      .item-hover {
        border: 2px solid #ff6615;
        position: relative;
      }
      .item-hover::after {
        content: '';
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAADf0lEQVRogdWYWU8TURSAPyqVxd0okRfji8SouJCAQQUEF9zjkwlq9MVETfRB4g/xQTEafTESY/QvGEVRUlwxasR9AYLBiCB7aWsOcye2TVtmOjPtzJc0aTp3Zs53z7lnbicn0rioEyjBo/iAOuCDlwW6lcRHF8RjGp86oQuo9aKEL+q7LvEpi/GYxhd3gi7x2QOxTxEvIPxQEkNZiMc0iQSE78DqrEosK4cd56BkC/hmJB2Wm+IS35TEa2C2I0EmY2YBrNoJG45AUQn0/4C+xEszWQZ0RKI0o5nw50PVCShvgFkLoaQGlqxIOnw6AeErsAYYtjXQROTNhuqTsPk4zFkMY3/h+R3ofZf0lFQlFM0XJfEKmJV2gMUrITQBv75CeDL2WMF8qDwGNae0mR/+DYEb0HIJhn5ZFkC11vQllpbBtkYIjsKja/AlAJGIdmxOEVQcgrozkD8XRvqhvRnuX9REUmBGQJdYC3SYlpCyWFWvfZ/hh9FB+NkJhQug8ihsP6d1m/EhCDTDvQvTBo/BNRCPtIN1ptdEzxstIJn10j1Qe1orqTV7tcxI8OEQtF3XysZA8IJsp9NwmGI58BIoNDRaukvFYdjeqJWMzLTUdm4ezCvWxtxvgodXYKDnf3lNg9kSika24OuBF4YkgmPw9Bbk5MC2s5pEnnq8hIJa4K1X4U+3qSDSKaFo3iuJEUOjZdaf3Ya752GwV/ttchxamuDBZejvMh2AlQzoiESZykTBtKNHB6D9JvgLoXQ3dHVowf/tS+vmdggInUriuSEJycTHVvDnQffrtIPH4iJOhOydngD5dl40FVbXQDxvgY3AmGMRx2G3QBh4A2yRQrH52gmxW0AIKYldwIQD14/BCYGwmn3ZbhxwWsIJgYj6TKiu1OCkhBMCqDIaV4tZutIRpyScEogoCREYANqURNDuGzklgJKYVDMvEq3AQbsz4bRASAUs5TSoJPbZKeGkgE50JuTlwGOg3i6JTAmElURQZaNNPewsS2RCQEcvKV2kXf5oWpXIpIBOJCor0mI3WZHIhgBREsJTK5nIlkA8komqdCTcIoBaE9VmJdwkIATMdie3CaBabK3RbYcbBVAPO0MSbhUQHhmRcLMASqIulYTbBVAbwK3J3sV6QUB4COxO9AbQKwLCA/WiIEbCSwIoiZhMeE1AaAH26hJeFBDuAfuBkX/fVQZb1POAHgAAAABJRU5ErkJggg==');
        background-repeat: no-repeat;
        background-size: 100%;
        width: 22px;
        height: 22px;
        position: absolute;
        right: -1px;
        top: -1px;
      }
      .item {
        float: left;
        width: 140px;
        margin-right: 15px;
        position: relative;
        .item_img {
          width: 140px;
          height: 140px;
          background: #eee;
          position: relative;
          background-size: 100% 100%;
        }
        .item_name {
          padding-top: 10px;
          padding-bottom: 10px;
          font-size: 14px;
        }
      }
      .item2 {
        float: left;
        width: 120px;
        margin-right: 15px;
        position: relative;
        .item_img {
          width: 120px;
          height: 120px;
          background: #eee;
          position: relative;
          background-size: 100% 100%;
        }
        .item_name {
          padding-top: 10px;
          padding-bottom: 10px;
          font-size: 14px;
        }
      }
      .item3 {
        float: left;
        width: 100px;
        margin-right: 15px;
        position: relative;
        .item_img {
          width: 100px;
          height: 100px;
          background: #eee;
          position: relative;
          background-size: 100% 100%;
        }
        .item_name {
          padding-top: 10px;
          padding-bottom: 10px;
          font-size: 12px;
        }
      }
    }
  } // .parameter_box::after {
  //   content: '';
  //   position: absolute;
  //   height: 1px;
  //   background-color: #eee;
  //   left: 0;
  //   bottom: 0;
  //   width: 100%;
  // }
  .parameter_item {
    float: left;
    line-height: 40px;
    width: 100%;
  }
  .diy_parameter {
    position: absolute;
  }
  .view-li {
    overflow: hidden;
    display: block;
    width: 100%;
    .parameter_item2 {
      width: 98%;
      background: #fff;
      margin: auto;
      margin-bottom: 1px;
      padding: 15px;
      box-sizing: border-box;
      .itme_li {
        font-size: 14px;
        span {
          float: right;
          color: #000;
        }
      }
      .zitem_li {
        padding-top: 20px;
        font-size: 14px;
        span {
          float: right;
          color: #000;
        }
      }
      .remarks {
        color: #999;
        font-size: 12px;
      }
    }
  }
  .red {
    color: red;
  }
  .item_text {
    height: 45px;
    border-radius: 2px;
    text-align: center;
    line-height: 45px;
    border: 2px solid #eee;
  }
</style>

<template>
  <div class="main">
    <div class="nav">
      <Icon size="24" @click="$router.go(-1)" color="#fff" type="ios-arrow-back" />
      <span>为本定制</span>
    </div>
    <div class="diy-box">
      <Spin size="large" fix v-if="load">加载中...</Spin>
      <!-- 步骤循环 -->
      <div class="diy-li" v-for="(item,index) in rdata" v-show="step == index" :key="index">
        <!-- 步骤名称 -->
        <div class="step_name"> {{item.step_name}}</div>
        <!-- 定制参数循环 -->
        <div class="parameter_li" v-for="(ite,idx) in item.zlist" :key="'s'+idx">
          <div class="parameter_name"> {{ite.parameter_name}}</div>
          <!-- 方案一 -->
          <div class="parameter_box">
            <div :style="{'width':ite.diy_item.length*220+'px'}">
              <div v-for="(a,ai) in ite.diy_item" class="item" @click="setValue(ite,ai)">
                <template v-if="ite.show_type == 1">
                 <div class="item_img" 
                 :class="{'item-hover':isValue(ite,ai)}" 
                 :style="{'background-image':'url('+a.item_img+')'}">
                  <Icon type="md-create" size="22" @click.stop="editbz(ite,ai)" v-show="isValue(ite,ai)" />
                 </div>
                 <div class="item_name">{{a.item_name}}</div>
               </template>
                <template v-if="ite.show_type == 2">
                  <div class="item_text" :class="{'item-hover':isValue(ite,ai)}">
                    <Icon type="md-create" 
                    size="18" 
                    @click.stop="editbz(ite,ai)" v-show="isValue(ite,ai)" /> {{a.item_name}}
                  </div>
                </template>
              </div>
            </div>
          </div>


<template v-if="ite.diy_item.length">
  <div v-for="a in ite.diy_item[ite.subIndex].diy_parameter" style="margin-left:15px;">
    <div class="parameter_name">{{a.parameter_name}}</div>
    <div class="parameter_box">
      <div :style="{'width':a.diy_item.length*220+'px'}">
        <div v-for="(b,bi) in a.diy_item" class="item2" @click="setValue(a,bi)">
          <template v-if="a.show_type == 1">
               <div class="item_img" 
               :class="{'item-hover':isValue(a,bi)}" 
               :style="{'background-image':'url('+b.item_img+')'}">
                <Icon type="md-create" size="22" @click.stop="editbz(a,bi)" v-show="isValue(a,bi)" />
                </div>
                <div class="item_name">{{b.item_name}}</div>
          </template>
          <template v-if="a.show_type == 2">
            <div class="item_text" :class="{'item-hover':isValue(a,bi)}">
              <Icon type="md-create" size="18" @click.stop="editbz(a,bi)" v-show="isValue(a,bi)" /> {{b.item_name}}
            </div>
          </template>
        </div>
       </div>
    </div>
                                
      <template v-if="a.diy_item.length">
        <div v-for="c in a.diy_item[a.subIndex].diy_parameter" style="margin-left:15px;">
          <div class="parameter_name"> {{c.parameter_name}}</div>
          <div class="parameter_box">
            <div :style="{'width':c.diy_item.length*220+'px'}">
              <div v-for="(d,di) in c.diy_item" class="item3" @click="setValue(c,di)">
                <template v-if="c.show_type == 1">
                  <div class="item_img"
                   :class="{'item-hover':isValue(c,di)}" 
                   :style="{'background-image':'url('+d.item_img+')'}">
                    <Icon type="md-create" size="22" @click.stop="editbz(c,di)" v-show="isValue(c,di)" />
                  </div>
                  <div class="item_name">{{d.item_name}}</div>
                </template>
                <template v-if="c.show_type == 2">
                  <div class="item_text" :class="{'item-hover':isValue(c,di)}">
                    <Icon type="md-create" size="18" @click.stop="editbz(c,di)" v-show="isValue(c,di)" /> {{d.item_name}}
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </template>
      </div>
</template>

      <div class="parameter_li" v-for="(otem,oidx) in ite.oneArray" >
              <div class="parameter_name"> {{otem.parameter_name}}|{{otem.show_type}}</div>
              <div class="parameter_box">
                <div :style="{'width':otem.diy_item.length*220+'px'}">
                  <div v-for="(dit,ix) in otem.diy_item" class="item" @click="setValue(index,idx,ix)">
                    <div class="item_img" :style="{'background-image':'url('+dit.item_img+')'}"></div>
                    <div class="item_name">{{dit.item_name}}</div>
                    <div v-for="k in otem.diy_item[ix].diy_parameter">
                      {{k.parameter_name}}
                        <div v-for="a in k.diy_item">
                          <div class="item_img" :style="{'background-image':'url('+a.item_img+')'}"></div>
                          {{a.item_name}}
                        </div>
                    </div>
                  </div>
                </div>
              </div>
        </div>
        </div>
      </div>
    </div>





<div class="diy-li" v-show="step == rdata.length">
    <div v-for="(item,index) in rdata">
        <div class="step_name" style="margin-top:15px;"> {{item.step_name}}
            <Icon type="md-create" style="float:right;margin-right:15px;" color="#999999" size="22"
                @click="step=index;edit=true" />
        </div>
        <div class="view-li">
          <template v-if="item.zlist.length">
            
            <div class="parameter_item2" v-for="(ite,idx) in item.zlist">
                <div class="itme_li">{{ite.parameter_name}}
                    <span>
                      
                      <template v-if="ite.diy_item.length">
                     
                      <template v-if="ite.type == 1">
                            {{ite.diy_item[ite.value].item_name}}
                            <i class="red" v-show="ite.diy_item[ite.value].price > 0">+{{ite.diy_item[ite.value].price}}
                                {{ite.diy_item[ite.value].price_type == 2 ? '[次]' : ''}}</i>
                        </template>

                        <template v-if="ite.type == 2">
                            <span v-for="(it,ix) in ite.value">
                                {{ite.diy_item[ix].item_name}}
                                <i class="red"
                                    v-show="ite.diy_item[ix].price > 0">+{{ite.diy_item[ix].price}}{{ite.diy_item[ix].price_type == 2 ? '[次]' : ''}}</i>、</span>
                        </template> 
                     </template>
                    </span>
                </div>

                <template v-if="ite.type == 1">
                    <template v-if="ite.diy_item.length">
                    <div class="remarks">  
                      {{ite.diy_item[ite.value].select}}{{ite.diy_item[ite.value].remarks}}
                      </div>
                  
                        <template v-if="ite.diy_item[ite.value].diy_parameter.length">
                            <div class="zitem_li" style="margin-left:15px;"
                                v-for="(a,ai) in ite.diy_item[ite.value].diy_parameter">
                                {{a.parameter_name}}
                                <span>{{a.diy_item[a.subIndex].item_name}}
                                    <i class="red"
                                        v-show="a.diy_item[a.subIndex].price > 0">+{{a.diy_item[a.subIndex].price}}
                                        {{a.diy_item[a.subIndex].price_type == 2 ? '[次]' : ''}}
                                    </i>
                                </span>
                                <div class="remarks">{{a.diy_item[a.subIndex].select}}{{a.diy_item[a.subIndex].remarks}}
                                </div>
                                <template v-if="a.diy_item[a.subIndex].diy_parameter.length">
                                    <div class="zitem_li" style="margin-left:15px;"
                                        v-for="(b,bi) in a.diy_item[a.subIndex].diy_parameter">
                                        {{b.parameter_name}}
                                        <span>{{b.diy_item[b.subIndex].item_name}}
                                            <i class="red"
                                                v-show="b.diy_item[b.subIndex].price > 0">+{{b.diy_item[b.subIndex].price}}
                                                {{b.diy_item[b.subIndex].price_type == 2 ? '[次]' : ''}}
                                            </i></span>
                                        <div class="remarks">
                                            {{b.diy_item[b.subIndex].select}}{{b.diy_item[b.subIndex].remarks}}</div>
                                    </div>
                                </template>
                            </div>
                        </template>
                    </template>
                </template>





            </div>
             </template>
        </div>
    </div>


</div>



    <Modal v-model="modeal" title="添加备注" :mask-closable="false"  @on-ok="completeSave">
      <Form label-position="top">
          <FormItem label="内置数据" v-show="cityList.length">
              <Select v-model="select" filterable multiple>
                <Option v-for="item in cityList" :value="item" :key="item">{{ item }}</Option>
              </Select>
          </FormItem>
          <FormItem label="备注">
              <Input type="textarea" v-model="remarks" :rows="4" placeholder="请填写备注" />
          </FormItem>
      </Form>
    </Modal>

    <div class="bottom-bar" v-show="!load">
      <div class="bar-left" @click="goHome">
        <Icon type="ios-home" size="25" />
        <div>首页</div>
      </div>
      <div class="bar-right">
         <div class="right-left" @click="setStep(false)" v-show="step != rdata.length">
          上一步
        </div> 

      <div class="right-left" style="font-size: 18px;color: #ff6615;font-weight: 700;padding-left: 25px;text-align: left;" v-show="step == rdata.length">
          <span style="font-size:14px;">¥</span> {{total_price}}
        </div>
        <div class="right-right" @click="setStep(true)">
          
          {{step != rdata.length ? '下一步' : '确认下单'}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  var that;
  import Store from 'store';
  import {
    POST
  } from "../plugins/core";
  import {
    constants
  } from 'fs';
  export default {
    name: 'diy',
    data() {
      return {
        cityList: [],
        select: [],
        remarks: "",
        modeal: false,
        edit: false,
        load: true,
        step: 0,
        tindex: 0,
        rdata: [],
        bhsk: {},
        diy_product: {
          price: 0
        }
      }
    },
    mounted() {
      that = this;
      that.init();
    },
    computed: {
      getValueText: function() {
        return 1;
      },
      total_price: function() {
        var di = parseFloat(this.diy_product.price);
        var d = 0;
        var cd = 0
        var diy_dataArr = this.rdata;
        for (let a in diy_dataArr) {
          a = diy_dataArr[a];
          for (let b in a.zlist) {
            b = a.zlist[b];
            console.log(b);
            if (b.type == 1) {

              if(b.diy_item.length){

                 if (b.diy_item[b.value].price_type == 1) {
                d += parseFloat(b.diy_item[b.value].price);
              } else {
                cd += parseFloat(b.diy_item[b.value].price);
              }
              if (b.diy_item[b.value].diy_parameter.length) {
                for (let c in b.diy_item[b.value].diy_parameter) {
                  c = b.diy_item[b.value].diy_parameter[c];
                  if (c.diy_item[c.subIndex].price_type == 1) {
                    d += parseFloat(c.diy_item[c.subIndex].price);
                  } else {
                    cd += parseFloat(c.diy_item[c.subIndex].price);
                  }
                  if (c.diy_parameter) {
                    for (let d in c.diy_item[c.subIndex].diy_parameter) {
                      d = c.diy_item[c.subIndex].diy_parameter[d];
                      if (d.diy_item[d.subIndex].price_type == 1) {
                        d += parseFloat(d.diy_item[d.subIndex].price);
                      } else {
                        cd += parseFloat(d.diy_item[d.subIndex].price);
                      }
                    }
                  }
                }
              }

              }
             
            }
          }
        }
        return (di + d).toFixed(2);
      }
    },
    methods: {
      completeSave() {
        that.bhsk.remarks = that.remarks;
        that.bhsk.select = that.select;
      },
      editbz(item, index) {
        console.log(item.diy_item[index].remarks);
        that.remarks = item.diy_item[index].remarks;
        that.select = item.diy_item[index].select || [];
        that.modeal = true;
        that.bhsk = item.diy_item[index];
        that.cityList = item.diy_item[index].built_data;
      },
      setItemValue(index, ites, idxm, ix) {
        that.rdata[index].zlist[ites].subordinate[idxm].value
        var subordinate = that.rdata[index].zlist[ites].subordinate;
        that.rdata[index].zlist[ites].subordinate[idxm].value = ix
        var invalid = that.rdata[index].zlist[ites].subordinate[idxm].item[ix].invalid;
        for (let i in subordinate) {
          for (let j in subordinate[i].item) {
            subordinate[i].item[j].show = true
            for (let x in invalid) {
              if (invalid[x].id == subordinate[i].item[j].id) {
                subordinate[i].item[j].show = false
              }
            }
          }
        }
      },
      //判断是否选中
      isValue(item, index) {
        if (item.type == 2) {
          if (item.value.indexOf(index) >= 0) return true;
        } else {
          if (item.value == index) return true;
        }
        return 0;
      },
      //获取初始化数据
      init() {
        var product_id = that.$route.params.id;
        POST('/getAdviserDiy', {
          product_id
        }).then(function(res) {
          that.load = false;
          console.log(1)
          if (res.state == 200) {
            that.rdata = res.data;
            that.diy_product = res.diy_product;
            // that.step = 10;
          }
        });
      },
      //点击选中
      setValue(item, index) {
        var type = item.type;
        if (type == 2) {
          if (item.value.indexOf(index) < 0) {
            item.value.push(index);
          } else {
            item.value.splice(item.value.indexOf(index), 1)
          }
        } else {
          item.value = index;
          item.subIndex = index
          console.log(item);
          // that.rdata[index].zlist[idx].subordinate = that.rdata[index].zlist[idx].zlist[ix].parameter;
          // console.log(that.rdata[index].zlist[idx].subordinate);
        }
      },
      setStep(up) {
        if (up) {
          if (!that.edit) {
            that.step += 1;
          } else {
            that.step = that.rdata.length;
            that.edit = false;
          }
          if (that.step >= that.rdata.length + 1) {
            that.step = that.rdata.length;
            //  console.log(that.rdata);
            that.$Modal.confirm({
              title: '已确认定制信息无误并下单?',
              onOk: () => {
                that.placeOrder();
              }
            });
          }
        } else {
          that.edit = false;
          that.step -= 1;
          if (that.step < 0) {
            that.step = 0;
            that.$Modal.confirm({
              title: '确定退出本次所选参数?',
              onOk: () => {
                that.$router.go(-1);
              }
            });
          }
        }
      },
      goHome() {
        that.$Modal.confirm({
          title: '确定退出本次所选参数,回到首页?',
          onOk: () => {
            that.$router.push({
              path: '/'
            })
          }
        });
      },
      placeOrder() {
        var product_id = that.$route.params.id;
        var enterprise_id = Store.get("enterprise_id");
        var diy_data = JSON.stringify(that.rdata);;
        that.load = true;
        POST('/getAdviserPlaceOrder', {
          product_id,
          enterprise_id,
          diy_data
        }).then(function(res) {
          that.load = false;
          if (res.state == 200) {
            that.$router.push({
              path: '/order/' + res.data.order_code
            })
          } else {
            that.$Message.error(res.msg);
          }
        });
      }
    }
  }
</script>
